/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../routing/state-utils';
import {NotFoundPageComponent} from './not-found-page.component';
import {Api404PageComponent} from './api404-page.component';
import {emptyRouteView, staticRouteTitleView} from '../common/directives/html/route-view-components';


export function errorStates(_adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
states.add('app.errors', {
          abstract: true
        }).add('app.errors.404', {
          url: '/404',
          resolve: {
            routeTitle: function() {
              return 'Page not found';
            }
          },
          views: {
            'title@app': staticRouteTitleView(),
            'context@app': emptyRouteView(),
            'content@app': {
              component: NotFoundPageComponent
            }
          },
          data: {
            title: "Sorry, your page wasn't found"
          }
        }).add('app.errors.wrong-app', {
          params: {appsToGo: []},
          views: {
            'content@app': {
              component: NotFoundPageComponent
            }
          },
          data: {
            title: "Sorry, your page wasn't found"
          }
        }).add('app.errors.api404', {
          url: '/not-found',
          resolve: {
            routeTitle: function() {
              return 'Data not found';
            }
          },
          views: {
            'title@app': staticRouteTitleView(),
            'context@app': emptyRouteView(),
            'content@app': {
              component: Api404PageComponent
            }
          },
          data: {
            title: "Data not found"
          }
        });
  return states.build();
}